import { Box, Divider, FormControl, FormLabel, Input, ModalBody, ModalFooter, Select } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import FormControlGroup from 'components/ui/FormControlGroup';
import SubmitButton from 'components/ui/SubmitButton';
import { useMessages } from 'hooks/useMessages';
import { FormProvider, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useCompaniesContext } from '../contexts/CompaniesContext';
import { useCompany } from '../hooks/useCompany';
import { RecipientInputs, useSaveCompanyRecipient } from '../hooks/useSaveCompanyRecipient';
import SelectLists from './SelectLists';

const validationSchema = Yup.object().shape({
  name: Yup.string(),
  email: Yup.string().email().required(),
  phone: Yup.string()
});


export default function FormMember() {
  const { companyId, modals } = useCompaniesContext();
  const { data: company } = useCompany(companyId);

  const defaultValues: RecipientInputs = {
    name: '',
    email: '',
    phone: '',
    listIds: [],
  };

  const methods = useForm<RecipientInputs>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as Resolver<RecipientInputs>,
    defaultValues
  });

  const { register, handleSubmit, reset, formState: { errors, isValid } } = methods;

  const { onError } = useMessages();

  const { 
    onSaveCompanyRecipient, 
    isPending,
  } = useSaveCompanyRecipient({ 
        companyId: companyId as string,
        onSuccess: ({ data: { recipient } }) => {
          reset();
          modals.createMember.onClose();
        },
        onError: (error) => onError(error?.response?.data?.message)
      });
      
  const onSubmit: SubmitHandler<RecipientInputs> = (data) => onSaveCompanyRecipient(data);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody>
          <FormControl isInvalid={!!errors.name}>
            <FormLabel>Nome</FormLabel>
            <Input {...register('name')} />
          </FormControl>

          <FormControlGroup>
            <FormControl isInvalid={!!errors.email} isRequired>
              <FormLabel>E-mail</FormLabel>
              <Input {...register('email')} />
            </FormControl>
            <FormControl isInvalid={!!errors.phone}>
              <FormLabel>Celular</FormLabel>
              <Input {...register('phone')} />
            </FormControl>
          </FormControlGroup>

          <FormControl>
            <FormLabel>Empresa</FormLabel>
            <Select disabled>
              <option value={companyId}>{company?.name}</option>
            </Select>
          </FormControl>

          <Divider my="38px" />
          
          <FormControl>
            <FormLabel>Associar a listas</FormLabel>
            <Box 
              borderRadius="19px"
              border="1px solid #E1E4EA"
              bg="white"
              padding="20px"
            >
            { company?.lists && <SelectLists lists={company.lists} /> }
            </Box>
          </FormControl>
        </ModalBody>  
        <ModalFooter>
          <SubmitButton 
            isDisabled={isPending || !isValid}
            isLoading={isPending}
            hideIcon
          >
            Adicionar
          </SubmitButton>
        </ModalFooter>
      </form>
    </FormProvider>
  )
}
